
import React from 'react';
import { User, Phone, Mail, Check, Download } from 'lucide-react';

interface OnboardingProgressBarProps {
  step: 'install' | 'info' | 'email' | 'verification' | 'phone' | 'success';
}

const OnboardingProgressBar: React.FC<OnboardingProgressBarProps> = ({ step }) => {
  const getStepIcon = () => {
    switch (step) {
      case 'install':
        return <Download className="w-6 h-6" />;
      case 'info':
        return <User className="w-6 h-6" />;
      case 'email':
        return <Mail className="w-6 h-6" />;
      case 'verification':
        return <Mail className="w-6 h-6" />;
      case 'phone':
        return <Phone className="w-6 h-6" />;
      case 'success':
        return <Check className="w-6 h-6" />;
    }
  };

  const getProgress = () => {
    switch (step) {
      case 'install':
        return "w-[16.7%]";
      case 'info':
        return "w-[33.4%]";
      case 'email':
        return "w-1/2";
      case 'verification':
        return "w-[66.7%]";
      case 'phone':
        return "w-[83.4%]";
      case 'success':
        return "w-full";
    }
  };

  return (
    <div className="w-full max-w-md mb-8">
      <div className="flex items-center mb-2">
        <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center">
          {getStepIcon()}
        </div>
        <div className="ml-3 flex-1">
          <div className="h-2 bg-gray-200 rounded-full">
            <div className={`h-full bg-blue-500 rounded-full ${getProgress()}`}></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OnboardingProgressBar;
